import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        label: {
            width: '120px'
        },
        value: {
            width: 'calc(100% - 120px)',
            position: 'relative'
        },
        error: {
            textWrap: 'wrap',
            position: "absolute",
            width: '100%',
            bottom: '-20px',
            right: 0
        }
    }
})